var $cdba2c398ab79b88$exports = {};
const $cdba2c398ab79b88$var$getSelector = (css)=>document.querySelector(css);
const $cdba2c398ab79b88$var$navButtons = document.querySelectorAll(".btn-nav");
const $cdba2c398ab79b88$var$firstTab = $cdba2c398ab79b88$var$getSelector("#first-container");
const $cdba2c398ab79b88$var$secondTab = $cdba2c398ab79b88$var$getSelector("#second-container");
const $cdba2c398ab79b88$var$thirdTab = $cdba2c398ab79b88$var$getSelector("#third-container");
const $cdba2c398ab79b88$var$ELEM = {
    ONE: 'one',
    TWO: 'two',
    THREE: 'three'
};
$cdba2c398ab79b88$var$navButtons.forEach((navButton)=>navButton.addEventListener("click", function() {
        const navAtciveButton = $cdba2c398ab79b88$var$getSelector(".btn-nav-active");
        const displayShow = $cdba2c398ab79b88$var$getSelector(".display-show");
        navAtciveButton.classList.remove("btn-nav-active");
        this.classList.add("btn-nav-active");
        displayShow.classList.remove("display-show");
        if (this.id === $cdba2c398ab79b88$var$ELEM.ONE) $cdba2c398ab79b88$var$firstTab.classList.add("display-show");
        if (this.id === $cdba2c398ab79b88$var$ELEM.TWO) $cdba2c398ab79b88$var$secondTab.classList.add("display-show");
        if (this.id === $cdba2c398ab79b88$var$ELEM.THREE) $cdba2c398ab79b88$var$thirdTab.classList.add("display-show");
    }));


//# sourceMappingURL=darkes.50285618.js.map
